<app-table [data]="toolReturns"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [saveFilters]="true"
           [isMaterial]="isMaterial"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           [title]="'atom.tool-returns.table.title-facilities' | translate"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column [header]="'atom.tool-returns.table.columns.createdDate' | translate"
                      [sortable]="false"
                      field="createdDate">
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.toolRequest' | translate"
                      [filterPlaceholder]="'atom.tool-returns.table.filter.toolRequest' | translate"
                      [filter]="true"
                      [sortable]="false"
                      field="toolRequestName">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.toolRequest.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.facility' | translate"
                      [filterPlaceholder]="'atom.tool-returns.table.filter.facility' | translate"
                      [filter]="true"
                      [sortable]="false"
                      field="facility">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.facility.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.createdBy' | translate"
                      [filterPlaceholder]="'atom.tool-returns.table.filter.createdBy' | translate"
                      [filter]="true"
                      [sortable]="false"
                      field="createdBy">
        <ng-template #body
                     let-toolReturn="rowData">
            <span>{{ toolReturn.createdBy.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.status' | translate"
                      [sortable]="false"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'atom.tool-returns.table.filter.status' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'atom.tool-returns.table.columns.action' | translate"
                      field="action">
        <ng-template #body
                     let-toolReturn="rowData">
            <app-button type="primary" *ngIf="isDelivered(toolReturn)"
                        class="process-button"
                        (click)="onActionClick(toolReturn, true)">{{ 'generic.buttons.process' | translate }}
            </app-button>
            <app-button type="warning" *ngIf="isWaitingForApproval(toolReturn)"
                        class="process-button"
                        (click)="onActionClick(toolReturn, false)">{{ 'generic.buttons.resume' | translate }}
            </app-button>
        </ng-template>
    </app-table-column>
</app-table>
